export { default as default } from './Columna';
